var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNearByIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M10.116,18.092c-.342,0-.677-.023-1-.053C6.8,17.78,5.25,16.715,5.25,15.389a1.971,1.971,0,0,1,.7-1.433.54.54,0,0,1,.738.79.968.968,0,0,0-.355.643c0,.615,1.085,1.371,2.9,1.575a9.856,9.856,0,0,0,1.777,0c1.807-.2,2.892-.959,2.892-1.573a.968.968,0,0,0-.355-.643.54.54,0,0,1,.738-.79,1.971,1.971,0,0,1,.7,1.433c0,1.326-1.552,2.391-3.862,2.649C10.793,18.07,10.458,18.092,10.116,18.092Z",
    transform: "translate(-1.116 -3.505)",
    fill: "#1a877a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M9,19.541c-4.346,0-7.75-2.137-7.75-4.866a4.085,4.085,0,0,1,2.088-3.335.541.541,0,1,1,.6.9,3.056,3.056,0,0,0-1.6,2.432c0,2.052,3.054,3.785,6.669,3.785s6.669-1.733,6.669-3.785a3.056,3.056,0,0,0-1.6-2.432.541.541,0,0,1,.6-.9,4.085,4.085,0,0,1,2.088,3.335C16.75,17.4,13.346,19.541,9,19.541Z",
    transform: "translate(0 -2.791)",
    fill: "#1a877a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M10.256,1.25A4.511,4.511,0,0,0,5.75,5.756c0,2.347,3.7,6.092,4.125,6.512a.541.541,0,0,0,.762,0c.422-.42,4.125-4.165,4.125-6.512A4.511,4.511,0,0,0,10.256,1.25Zm0,5.948A1.442,1.442,0,1,1,11.7,5.756,1.442,1.442,0,0,1,10.256,7.2Z",
    transform: "translate(-1.256 0)",
    fill: "#1a877a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearByIcon);
export default __webpack_public_path__ + "static/media/nearByIcon.27495522ae660ba7f8bfbd15441a1264.svg";
export { ForwardRef as ReactComponent };